module.exports = __webpack_public_path__ + "img/gml_4_splash.b5b76c0d.jpg";